import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import common from 'constants/common';

const EditRowMenu = ({ onEdit, onDelete, lastEdited }) => (
  <div className="editable-row__menu">
    <div className="editable-row__menu-item-delete" onClick={onDelete}>
      Delete
    </div>
    <div className="editable-row__menu-item-edit" onClick={onEdit}>
      Edit tab
    </div>
    <div className="editable-row__menu-item-author">
      <div>Last edited by {lastEdited.firstName}</div>
      <div>{format(new Date(lastEdited.date), common.dateFormats.short)}</div>
    </div>
  </div>
);

EditRowMenu.defaultProps = {
  onEdit: () => {},
  onDelete: () => {},
};

EditRowMenu.propTypes = {
  lastEdited: PropTypes.shape().isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default EditRowMenu;
